import { Box } from '@chakra-ui/react'
import React from 'react'

import RatioImage from '../../containers/RatioImage'

const Banner = ({ banner, isBannerDisabled, alt, isEditing, isPreview }) => {
  return (
    <Box px="2" pb={!isBannerDisabled && 2}>
      <Box
        rounded="md"
        overflow="hidden"
      >
        <RatioImage
          rounded="md"
          overflow="hidden"
          ratio={2}
          src={banner}
          alt={alt || '合作洽詢'}
          isEditing={isEditing}
          isPreview={isPreview}
          isDisabled={isBannerDisabled}

        />
      </Box>
    </Box>
  )
}

export default Banner
